import { render } from "./Summary.vue?vue&type=template&id=f6ccc808&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=f6ccc808&lang=scss&scoped=true"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ccc808"]])

export default __exports__